import { render } from "./BaseSpinner.vue?vue&type=template&id=21d4efca&scoped=true"
const script = {}

import "./BaseSpinner.vue?vue&type=style&index=0&id=21d4efca&scoped=true&lang=css"

import exportComponent from "C:\\JRIBIC\\Projects\\_myProjects\\_GIT\\general\\Vue.js\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d4efca"]])

export default __exports__